import React, { forwardRef, useRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Button from '../../Button/Button.js';
import DismissWizardButton from '../DismissWizardButton/DismissWizardButton.js';
import ProgressBar from '../ProgressBar/ProgressBar.js';
import { useIsOverflow } from '../../../services/hooks/useIsOverflow.js';
import { runningInApp } from '../../../services/appConstants/appConstants.js';
import styles from './Header.module.scss.js';
import deskStyles from './DesktopHeader.module.scss.js';

var Header = /*#__PURE__*/forwardRef(function (props, ref) {
  var onBack = props.onBack,
    backText = props.backText,
    backDisabled = props.backDisabled,
    backButtonDataTestId = props.backButtonDataTestId,
    closeDisabled = props.closeDisabled,
    title = props.title,
    descriptionText = props.descriptionText,
    currentStep = props.currentStep,
    onClose = props.onClose,
    closeText = props.closeText,
    animatedText = props.animatedText,
    progress = props.progress,
    noBackButton = props.noBackButton;
  var isFinish = currentStep === 'finish';
  var textContent = useRef(null);
  var isOverflow = useIsOverflow(textContent);
  var isCloseEnabled = function isCloseEnabled() {
    return closeText && !isFinish && !closeDisabled;
  };
  var isBackEnabled = function isBackEnabled() {
    return backText && !noBackButton && !isFinish;
  };
  var DesktopHeader = function DesktopHeader() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("section", {
      className: deskStyles.wizardHeaderDesktop
    }, descriptionText && /*#__PURE__*/React.createElement("p", {
      className: deskStyles.descriptionText
    }, descriptionText), isBackEnabled() && /*#__PURE__*/React.createElement(Button, {
      link: true,
      text: backText,
      onClick: onBack,
      className: classNames(deskStyles.headerButton, deskStyles.leftBtn),
      disabled: backDisabled,
      dataTestId: backButtonDataTestId
    }), /*#__PURE__*/React.createElement("h1", {
      className: classNames('title', deskStyles.title)
    }, title), /*#__PURE__*/React.createElement("div", {
      className: classNames(deskStyles.headerButton, deskStyles.rightBtn)
    }, isCloseEnabled() && /*#__PURE__*/React.createElement(DismissWizardButton, {
      onClose: onClose,
      closeText: closeText
    }))), /*#__PURE__*/React.createElement(ProgressBar, {
      progress: progress
    }));
  };
  return runningInApp ? /*#__PURE__*/React.createElement("section", {
    className: styles.wizardHeader,
    ref: ref
  }, descriptionText && /*#__PURE__*/React.createElement("p", {
    className: styles.descriptionText
  }, descriptionText), /*#__PURE__*/React.createElement("div", {
    className: styles.navigation
  }, /*#__PURE__*/React.createElement("h1", {
    ref: textContent,
    className: classNames('title', styles.title)
  }, /*#__PURE__*/React.createElement("p", {
    className: classNames(animatedText && isOverflow && styles.movingText, !animatedText && styles.ellip)
  }, title)), /*#__PURE__*/React.createElement("div", {
    className: styles.minWidth
  }, isBackEnabled() && /*#__PURE__*/React.createElement(Button, {
    link: true,
    text: backText,
    onClick: onBack,
    className: styles.leftBtn,
    disabled: backDisabled,
    dataTestId: backButtonDataTestId
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.rightBtn
  }, isCloseEnabled() && /*#__PURE__*/React.createElement(DismissWizardButton, {
    onClose: onClose,
    closeText: closeText
  }))), /*#__PURE__*/React.createElement(ProgressBar, {
    progress: progress
  })) : /*#__PURE__*/React.createElement(DesktopHeader, null);
});
Header.displayName = 'Header';
Header.propTypes = {
  onBack: PropTypes.func.isRequired,
  backText: PropTypes.string,
  backDisabled: PropTypes.bool,
  backButtonDataTestId: PropTypes.string,
  closeDisabled: PropTypes.bool,
  title: PropTypes.string.isRequired,
  descriptionText: PropTypes.string,
  currentStep: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  closeText: PropTypes.string,
  animatedText: PropTypes.bool,
  progress: PropTypes.number,
  noBackButton: PropTypes.bool
};
Header.defaultProps = {
  backDisabled: false,
  backButtonDataTestId: null,
  backText: null,
  closeDisabled: false,
  closeText: null,
  animatedText: false,
  progress: 0,
  descriptionText: null,
  noBackButton: false
};

export { Header as default };
